import { render, staticRenderFns } from "./DeviceList.vue?vue&type=template&id=128a0636&scoped=true&"
import script from "./DeviceList.vue?vue&type=script&lang=ts&"
export * from "./DeviceList.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceList.vue?vue&type=style&index=0&id=128a0636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128a0636",
  null
  
)

export default component.exports